import { render } from "./SportsSection.vue?vue&type=template&id=99595b8a"
import script from "./SportsSection.vue?vue&type=script&lang=js"
export * from "./SportsSection.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__